import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import styles from './footer-xsci.module.css'
import responsive from "./footer-xsci-responsive.module.css";
import {faEnvelope, faLocationDot, faPhone} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";

const ContactSection = () => {
    const {t, i18n} = useTranslation();


    return (

        <div className={`col-md-3 col-12 my-sm-0 mt-5 ${styles.section_container}`}>
            <ul className="list-unstyled">
                <li className={`mt-md-3 mt-4 ${styles.section_title}`}>Contact</li>
                <li className={styles.section_li}><FontAwesomeIcon
                    icon={faEnvelope}
                    style={{
                        fontSize: "18px",
                        color: "darkturquoise",
                        cursor: "pointer",
                        paddingRight: "10px"
                    }}/>
                    info@xsci.ca
                </li>
                <li className={styles.section_li}><FontAwesomeIcon
                    icon={faPhone}
                    style={{
                        fontSize: "18px",
                        color: "darkturquoise",
                        cursor: "pointer",
                        paddingRight: "10px"
                    }}/>
                    Ottawa: 613-468-7320
                </li>
                <li className={styles.section_li}><FontAwesomeIcon
                    icon={faPhone}
                    style={{
                        fontSize: "18px",
                        color: "darkturquoise",
                        cursor: "pointer",
                        paddingRight: "10px"
                    }}/>
                    Montreal: 514-512-6208
                </li>
                <li className={styles.section_li}><FontAwesomeIcon
                    icon={faLocationDot} className={responsive.location_icon}
                    style={{
                        fontSize: "18px",
                        color: "darkturquoise",
                        cursor: "pointer",
                        paddingRight: "10px"
                    }}/>
                    Kanata, Ontario
                </li>
            </ul>
        </div>

    );
};

export default ContactSection;